<template>
  <v-row no-gutters>
    <v-col cols="12" class="d-flex justify-center">
      <v-icon>mdi-arrow-down</v-icon>
    </v-col>
    <slot name="activator" v-bind:on="on"></slot>

    <v-dialog v-model="dialog" scrollable width="500">
      <v-card>
        <v-card-title
          >เพิ่มแอคชั่น<v-spacer></v-spacer
          ><v-btn icon color="primary" @click="dialog = false">
            <v-icon>mdi-close</v-icon></v-btn
          ></v-card-title
        >
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            filled
            hide-details
            v-model="keyword"
          ></v-text-field>
          <v-list v-for="group in types" :key="group.title">
            <v-subheader>{{ group.title }}</v-subheader>
            <v-list-item
              v-for="type in getFilterTypes(group.types)"
              :key="type.name"
              @click="newActionClick(type)"
            >
              <v-list-item-action>
                <v-icon v-text="type.icon"></v-icon>
              </v-list-item-action>
              <v-list-item-title>{{ type.title }}</v-list-item-title>
              <v-list-item-action>
                <v-icon>mdi-chevron-right</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: ["actions", "types"],

  data() {
    return {
      dialog: false,
      keyword: "",
      on: {
        apply: () => {
          this.dialog = true;
        },
      },
    };
  },

  methods: {
    getFilterTypes(types) {
      return types.filter((i) => i.title.toLowerCase().startsWith(this.keyword));
    },
    newActionClick(type) {
      var newAction = type.create();
      this.actions.push(newAction);
      this.dialog = false;
    },
  },
};
</script>

<style>
</style>